module.exports = __webpack_public_path__ + "img/e81fd69.jpg";